import React, { useRef, useState } from 'react';
import emailjs from 'emailjs-com';
import './contact.css';
import { FaWhatsapp, FaFacebookF, FaYoutube, FaInstagram } from 'react-icons/fa';
import Navbar from './Navbar';
import Footer from './Footer';
import Nav from './Nav';

export default function Contact() {
  const contactFormRef = useRef();
  const [sending, setSending] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');
  const [statusType, setStatusType] = useState(''); // 'success' | 'error'

  const sendContactMessage = (e) => {
    e.preventDefault();

    const phoneInput = contactFormRef.current.user_phone.value;
    const indianPhoneRegex = /^[6-9]\d{9}$/;
    if (!indianPhoneRegex.test(phoneInput)) {
      setStatusType('error');
      setStatusMessage('Please enter a valid 10-digit Indian phone number.');
      setTimeout(() => setStatusMessage(''), 4000);
      return;
    }

    setSending(true);
    setStatusMessage('');

    emailjs
      .sendForm(
        'service_wyii6me',
        'template_94vg4ub',
        contactFormRef.current,
        'cdndB-llSLqWB7XFF'
      )
      .then(() => {
        setSending(false);
        setStatusType('success');
        setStatusMessage('Message sent successfully! We will get back to you soon.');
        contactFormRef.current.reset();
        setTimeout(() => setStatusMessage(''), 5000);
      })
      .catch(() => {
        setSending(false);
        setStatusType('error');
        setStatusMessage('Failed to send message. Please try again or call us directly.');
        setTimeout(() => setStatusMessage(''), 4000);
      });
  };

  const faqs = [
    {
      q: 'How long does delivery take across India?',
      a: 'Orders are dispatched within 24 to 48 business hours via registered courier or speed post. Most deliveries arrive within 3 to 7 business days depending on your location.'
    },
    {
      q: 'What payment options are available?',
      a: 'We accept UPI (Google Pay, PhonePe, Paytm), Credit/Debit Cards, and Net Banking through our secure Razorpay payment gateway.'
    },
    {
      q: 'How can I track my shipment?',
      a: 'Once your book order is shipped, a tracking number is automatically updated in your Profile orders section, and confirmation is sent via email and SMS.'
    },
    {
      q: 'Are wholesale or bulk institutional discounts available?',
      a: 'Yes, we provide special educational discounts for music universities, colleges, music academies, and music teachers. Please reach out to us directly by phone or WhatsApp.'
    },
    {
      q: 'Are all books authentic and syllabus compliant?',
      a: 'Yes, all our publications, including Bhatkhande Kramik Pustak Malika and classical theory treatises, are authentic Sangit Shree Prakashan publications recommended for academic syllabi.'
    },
    {
      q: 'How can I change my delivery address after ordering?',
      a: 'If your order has not been dispatched yet, please contact our support team immediately via phone or WhatsApp with your Order ID to update the shipping details.'
    }
  ];

  return (
    <div className="contact-page-wrapper">
      <Navbar />

      <main className="contact-main-container">
        {/* Page Title */}
        <div className="contact-header-area">
          <h1 className="contact-page-title">Contact Us</h1>
        </div>

        {/* Top Two-Column Section: Form (Left) & Direct Info (Right) */}
        <section className="contact-top-grid">
          {/* Left: Contact Form Card */}
          <div className="contact-card-box">
            <form ref={contactFormRef} onSubmit={sendContactMessage} className="contact-clean-form">
              <div className="contact-field-group">
                <label htmlFor="user_name">NAME</label>
                <input
                  type="text"
                  id="user_name"
                  name="user_name"
                  placeholder="Your Full Name"
                  required
                />
              </div>

              <div className="contact-field-group">
                <label htmlFor="user_email">EMAIL ADDRESS</label>
                <input
                  type="email"
                  id="user_email"
                  name="user_email"
                  placeholder="your.email@example.com"
                  required
                />
              </div>

              <div className="contact-field-group">
                <label htmlFor="user_phone">PHONE NUMBER</label>
                <input
                  type="tel"
                  id="user_phone"
                  name="user_phone"
                  placeholder="10-digit mobile number"
                  maxLength="10"
                  required
                />
              </div>

              <div className="contact-field-group">
                <label htmlFor="message">MESSAGE</label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  placeholder="How can we help you?"
                  required
                ></textarea>
              </div>

              {statusMessage && (
                <div className={`contact-status-alert ${statusType}`}>
                  {statusMessage}
                </div>
              )}

              <div className="contact-submit-row">
                <button type="submit" className="contact-submit-btn" disabled={sending}>
                  {sending ? 'SENDING...' : 'SUBMIT'}
                </button>
              </div>
            </form>
          </div>

          {/* Right: Info Details */}
          <div className="contact-side-info">
            <div className="contact-info-block">
              <h3 className="contact-info-label">Email Us</h3>
              <p className="contact-info-val">
                <a href="mailto:sangitshreeprakashan@gmail.com">sangitshreeprakashan@gmail.com</a>
              </p>
              <p className="contact-info-val">
                <a href="mailto:info@sangitshreeprakashan.com">info@sangitshreeprakashan.com</a>
              </p>
            </div>

            <div className="contact-info-block">
              <h3 className="contact-info-label">Call Us</h3>
              <p className="contact-info-val">
                <a href="tel:+917408452828">+91 740-845-2828</a>
              </p>
              <p className="contact-info-val">
                <a href="tel:+919336112507">+91 933-611-2507</a>
              </p>
            </div>

            <div className="contact-info-block">
              <h3 className="contact-info-label">Follow & Connect</h3>
              <div className="contact-social-icons">
                <a
                  href="https://wa.me/917408452828"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="WhatsApp"
                  className="social-icon-btn"
                >
                  <FaWhatsapp />
                </a>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="social-icon-btn"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                  className="social-icon-btn"
                >
                  <FaYoutube />
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="social-icon-btn"
                >
                  <FaInstagram />
                </a>
              </div>
            </div>

            <div className="contact-info-block">
              <h3 className="contact-info-label">Visit Us!</h3>
              <p className="contact-info-address">
                Shop No. 116, Nagar Nigam Market,<br />
                Vikas Nagar, Gurudev Zoo Road,<br />
                In front of Manorma Marriage Palace,<br />
                Kanpur - 208002, Uttar Pradesh, India
              </p>
            </div>
          </div>
        </section>

        {/* Middle Section: Full-Width Map */}
        <section className="contact-map-wrapper">
          <iframe
            src="https://www.google.com/maps?q=Shop+No.+116,+Vikas+Nagar,+In+front+of+Manorma+Marriage+Palace,+Sangit+Shree+Prakashan,+Kanpur+Nagar&output=embed"
            allowFullScreen
            loading="lazy"
            title="Sangit Shree Prakashan Location"
            className="contact-map-frame"
          ></iframe>
        </section>

        {/* Bottom Section: F. A. Q. */}
        <section className="contact-faq-section">
          <h2 className="contact-faq-heading">F. A. Q.</h2>
          <div className="contact-faq-grid">
            {faqs.map((item, idx) => (
              <div key={idx} className="faq-card-item">
                <h4 className="faq-question">{item.q}</h4>
                <p className="faq-answer">{item.a}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Bottom Centered Details */}
        <section className="contact-bottom-summary">
          <div className="bottom-detail-group">
            <span className="bottom-tag">ADDRESS</span>
            <p>Shop No. 116, Nagar Nigam Market, Vikas Nagar, Kanpur - 208002</p>
          </div>
          <div className="bottom-detail-group">
            <span className="bottom-tag">EMAIL</span>
            <p>
              <a href="mailto:info@sangitshreeprakashan.com">info@sangitshreeprakashan.com</a>
            </p>
          </div>
          <div className="bottom-detail-group">
            <span className="bottom-tag">PHONE</span>
            <p>
              <a href="tel:+917408452828">+91 740-845-2828</a>
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
